import fetch from "./optionsFetch";
import React from "react";
import { Grid, GridColumn, GridToolbar, GridColumnMenuCheckboxFilter } from "@progress/kendo-react-grid";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { GridPDFExport } from "@progress/kendo-react-pdf";
import DataLoader from "./dataLoader";
import configData from "../config.json";
import { Button } from "@progress/kendo-react-buttons";
import { NumericTextBox, TextBox } from "@progress/kendo-react-inputs";
import { GetSession, GetToken } from './Session';
import ColumnMenu from '../pages/ColumnMenu';
import Confirm from '../components/Confirm';
import { formatDate, formatNumber } from '@progress/kendo-intl';
import { Checkbox } from '@progress/kendo-react-inputs';
import { DatePickerPropsContext } from '@progress/kendo-react-dateinputs';
import { useNavigate, useParams } from "react-router-dom";
import { HeaderThElement } from "@progress/kendo-react-data-tools";
import {
    Notification,
    NotificationGroup,
} from "@progress/kendo-react-notification";
import { Fade } from "@progress/kendo-react-animation";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import $ from "jquery"
import { process } from '@progress/kendo-data-query';
import { setGroupIds } from '@progress/kendo-react-data-tools';
import "./DataGrid.scss";

const DataGrid = (props) => { // use props.update for force grid update for outside this component
    // colour definitions
    const editCol = { background: '#2494e8', color: '#ffffff' };       // edit buttons � modern green
    const delCol = { background: '#E53935', color: '#ffffff' };        // delete buttons � vibrant red
    const newCol = { background: '#1E88E5', color: '#ffffff' };        // new record button � primary blue
    const printCol = { background: '#FDD835', color: '#000000' };      // print button � warm yellow
    const pdfCol = { background: '#5E35B1', color: '#ffffff' };        // pdf button � deep purple
    const feeCol = { background: '#00ACC1', color: '#ffffff' };        // fee button � cyan/teal
    const convCol = { background: '#26C6DA', color: '#ffffff' };       // convert button � light cyan
    const myobCol = { background: '#66BB6A', color: '#ffffff' };       // myob button � muted green
    const statusActiveCol = { background: '#81C784', color: '#ffffff' };   // active status � soft green
    const statusInactiveCol = { background: '#EF9A9A', color: '#ffffff' }; // inactive status � soft red
    const importCol = { background: '#FFEE58', color: '#000000' };     // import button � soft yellow
    const checkboxCol = { background: '#90CAF9', color: '#000000' };   // checkboxes � light blue
    const clearCol = { background: '#FF7043', color: '#ffffff' };      // clear filter � noticeable orange/red

    const dataSource = props.dataSource;
    const extraParam = props.extraParam === undefined ? "" : props.extraParam; // used for passing extra parameters for edit, eg "/S" for suppliers or "/C" for customers
    const dataFilter = props.dataFilter === undefined ? "" : props.dataFilter;
    const aggregates = props.subTotals;
    const options = props.options;
    let deleteAll = props.deleteAll !== undefined;
    let extraButton = props.extraButton;
    const extraButtonUrl = props.extraButtonUrl;
    const sortable = props.sortable === undefined ? true : props.sortable;
    const filterable = props.filterable === undefined ? true : props.filterable;
    const params = props.params;
    const Approve = props.approve;
    const setVisibility = props.setVisibility;
    const viewName = props.viewName === undefined ? String(dataSource).replace("apiv7/", "") : props.viewName;
    let editUrl = "/edit" + String(dataSource).replace("apiv7/", "") + extraParam;
    if (props.editUrl !== undefined) editUrl = props.editUrl;
    let printUrl = "/print" + String(dataSource).replace("apiv7/", "") + extraParam;
    if (props.printUrl !== undefined) printUrl = props.printUrl;
    const permissions = props.permissions || { CanEdit: true, CanDelete: true, CanPrint: false, CanCreate: true, CanReport: true, CanApprove: false };
    const canEdit = permissions.CanEdit;
    const canDelete = permissions.CanDelete;
    const canCreate = permissions.CanCreate;
    const canPrint = permissions.CanPrint;
    const canReport = permissions.CanReport;
    const canExport = props.exportRecord !== undefined;
    const canImport = props.importFile !== undefined;
    const [success, setSuccess] = React.useState(false);
    const canApprove = permissions.CanApprove && Approve !== undefined;
    const syncMyob = permissions.SyncMyob;
    if (!canEdit) extraButton = undefined;
    if (!canDelete) deleteAll = false;
    const columns = props.columns;
    const keyField = props.keyField;
    const navigate = useNavigate();
    const [showDlg, setShowDlg] = React.useState(false);
    const [selected, setSelected] = React.useState(0);
    let newRecordBtn = "";
    const [apiData, setData] = React.useState({ data: [], total: 0 });
    const [dataState, setDataState] = React.useState({ skip: 0, take: 0 });
    const [gridKey, setGridKey] = React.useState();
    const [visIds, setVisIds] = React.useState("");
    const [showExportPDF, setShowExportPDF] = React.useState(false);
    const [showExportMenu, setShowExportMenu] = React.useState(false);
    const [exportMenuPosition, setExportMenuPosition] = React.useState(null);
    const exportButtonRef = React.useRef(null);
    const bulkExport = props.bulkExport !== undefined;
    const bulkStatus = props.bulkStatus !== undefined;
    const selectedIds = React.useRef([]);
    const customCommand = props.customCommand;
    const customCommandName = props.customCommandName;
    const rowStyle = props.rowStyle; // callback function for setting style of rows
    let minWidth = (canEdit ? 34 : 0) + (canDelete ? 34 : 0) + (canApprove ? 34 : 0) + (canExport ? 34 : 0) + (canPrint ? 34 : 0) + (extraButton !== undefined ? 74 : 0) + (customCommand !== undefined ? 74 : 0);
    if (minWidth > 0 && minWidth < 92) minWidth = 96;
    let colWidth = minWidth + "px";
    const totalRecords = React.useRef(0);
    const [pendingExport, setPendingExport] = React.useState(null);
    const [pendingRecordExport, setPendingRecordExport] = React.useState(null);
    const [pendingBulkDownload, setPendingBulkDownload] = React.useState(null);
    const [exportInProgress, setExportInProgress] = React.useState(false);
    const [exportProgressMode, setExportProgressMode] = React.useState("export");
    const [exportError, setExportError] = React.useState("");
    const lastParams = React.useRef("");
    const initialSelected = props.selectedId;
    const [forceUpdate, setForceUpdate] = React.useState();
    const datePickerProps = React.useCallback( // fix date format for filter and edit in grid
        (datePickerProps) => ({
            ...datePickerProps,
            format: 'dd/MM/yy',
        }),
        []
    );
    const [filterActive, setFilterActive] = React.useState(false);
    let lastSearchText = localStorage.getItem(dataSource + "Search");
    if (lastSearchText === null) lastSearchText = "";
    const [searchText, setSearchText] = React.useState(lastSearchText);
    const [searchEntry, setSearchEntry] = React.useState(lastSearchText);
    const searchHandler = React.useRef(null);
    React.useEffect(() => {
        if (searchEntry === searchText || dataState.take === 0) return;
        const timer = setTimeout(() => searchHandler.current(), 800);
        return () => clearTimeout(timer);
    }, [searchEntry, searchText, dataState.take]);
    const [filterTitle, setFilterTitle] = React.useState("Clear Filters");
    const gridContainerRef = React.useRef(null);
    const [gridMaxHeight, setGridMaxHeight] = React.useState(props.maxHeight || "calc(100vh - 185px)");
    const [gridContainerWidth, setGridContainerWidth] = React.useState(0);

    const toggleExportMenu = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (!exportButtonRef.current) {
            setShowExportMenu((open) => !open);
            return;
        }

        const bounds = exportButtonRef.current.getBoundingClientRect();
        setExportMenuPosition({
            top: Math.floor(bounds.bottom + 7),
            left: Math.floor(bounds.left),
            width: Math.floor(bounds.width)
        });
        setShowExportMenu((open) => !open);
    };

    React.useEffect(() => {
        if (!showExportMenu) return;

        const closeExportMenu = () => setShowExportMenu(false);
        const closeExportMenuOnEscape = (event) => {
            if (event.key === "Escape") closeExportMenu();
        };

        document.addEventListener("click", closeExportMenu);
        document.addEventListener("keydown", closeExportMenuOnEscape);
        window.addEventListener("resize", closeExportMenu);
        window.addEventListener("scroll", closeExportMenu, true);

        return () => {
            document.removeEventListener("click", closeExportMenu);
            document.removeEventListener("keydown", closeExportMenuOnEscape);
            window.removeEventListener("resize", closeExportMenu);
            window.removeEventListener("scroll", closeExportMenu, true);
        };
    }, [showExportMenu]);

    const getReadableColumnWidthNumber = (column) => {
        const field = String(column.field || "").toLowerCase();
        const title = String(column.label || column.title || column.field || "");
        const currentWidth = parseInt(column.width, 10);
        let minColumnWidth = Math.max(96, title.length * 8 + 44);

        if (column.type === "date" || field.includes("date") || field.includes("time")) minColumnWidth = Math.max(minColumnWidth, 142);
        if (field.includes("name") || field.includes("customer") || field.includes("supplier") || field.includes("product") || field.includes("site")) minColumnWidth = Math.max(minColumnWidth, 154);
        if (field.includes("description") || field.includes("address") || field.includes("comment")) minColumnWidth = Math.max(minColumnWidth, 190);
        if (field.includes("total") || field.includes("cost") || field.includes("price") || field.includes("gross") || field.includes("tare") || field.includes("net")) minColumnWidth = Math.max(minColumnWidth, 110);
        if (field.includes("status")) minColumnWidth = Math.max(minColumnWidth, 104);

        const width = Number.isFinite(currentWidth) ? Math.max(currentWidth, minColumnWidth) : minColumnWidth;
        return width;
    };

    const getReadableColumnWidth = (column) => {
        if (!stateColumns || gridContainerWidth <= 0) return `${getReadableColumnWidthNumber(column)}px`;

        const visibleColumns = stateColumns.filter((c) => c.isVisible);
        const selectWidth = bulkExport || bulkStatus ? 44 : 0;
        const actionWidth = parseInt(colWidth, 10) || 0;
        const gridChromeWidth = 30;
        const availableColumnWidth = gridContainerWidth - selectWidth - actionWidth - gridChromeWidth;
        const minimumColumnsWidth = visibleColumns.reduce((total, c) => total + getReadableColumnWidthNumber(c), 0);

        if (availableColumnWidth <= minimumColumnsWidth || minimumColumnsWidth <= 0) {
            return `${getReadableColumnWidthNumber(column)}px`;
        }

        const extraWidth = availableColumnWidth - minimumColumnsWidth;
        const columnMinimumWidth = getReadableColumnWidthNumber(column);
        const stretchedWidth = columnMinimumWidth + (extraWidth * columnMinimumWidth / minimumColumnsWidth);
        return `${Math.floor(stretchedWidth)}px`;
    };

    React.useLayoutEffect(() => {
        if (props.maxHeight) {
            setGridMaxHeight(props.maxHeight);
            return;
        }

        const updateGridHeight = () => {
            if (!gridContainerRef.current) return;
            const bounds = gridContainerRef.current.getBoundingClientRect();
            const top = bounds.top;
            const bottomGap = window.innerWidth <= 768 ? 12 : 16;
            const height = Math.max(320, window.innerHeight - top - bottomGap);
            setGridMaxHeight(`${height}px`);
            setGridContainerWidth(Math.floor(bounds.width));
        };

        updateGridHeight();
        window.addEventListener("resize", updateGridHeight);
        let observer;
        if (typeof ResizeObserver !== "undefined") {
            observer = new ResizeObserver(updateGridHeight);
            observer.observe(gridContainerRef.current);
            observer.observe(document.body);
            if (gridContainerRef.current.parentElement) observer.observe(gridContainerRef.current.parentElement);
        }

        return () => {
            window.removeEventListener("resize", updateGridHeight);
            if (observer) observer.disconnect();
        };
    }, [props.maxHeight]);
    // handle pagination and page sizes
    let lastPageSize = localStorage.getItem(dataSource + "PageSize");
    if (lastPageSize === null || lastPageSize === "" || lastPageSize === "0") lastPageSize = 10;
    else if (lastPageSize !== "All") {
        lastPageSize = parseInt(lastPageSize);
        if (isNaN(lastPageSize) || lastPageSize === 0) lastPageSize = 10;
    }
    const [pageSizeValue, setPageSizeValue] = React.useState(lastPageSize);
    const pageSizeToTake = (value) => value === "All" ? 999999 : parseInt(value);
    const filterOperators = {
        text: [{
            text: 'grid.filterContainsOperator',
            operator: 'contains'
        }],
        numeric: [
            { text: 'grid.filterEqOperator', operator: 'eq' },
            { text: 'grid.filterGtOperator', operator: 'gt' },
            { text: 'grid.filterLtOperator', operator: 'lt' },
        ],
        date: [
            { text: 'grid.filterEqOperator', operator: 'eq' },
            { text: 'grid.filterAfterOrEqualOperator', operator: 'gte' },
            { text: 'grid.filterBeforeOrEqualOperator', operator: 'lte' },
        ],
        boolean: [{
            text: 'grid.filterEqOperator',
            operator: 'eq'
        }]
    };
    const pageChange = (event) => {
        const targetEvent = event.targetEvent;
        let ds = { ...dataState };
        if (targetEvent?.value) {
            setPageSizeValue(targetEvent.value);
            localStorage.setItem(dataSource + "PageSize", targetEvent.value);
            ds.skip = 0;
            if (targetEvent.value === 'All')
                ds.take = 999999;
            else
                ds.take = targetEvent.value;
        } else {
            ds.skip = event.page?.skip ?? event.skip ?? 0;
            ds.take = event.page?.take ?? event.take ?? ds.take;
        }
        updateDataState(ds);
    }

    // handle datastate changes. This could be sort order or filter changes
    const dataStateChange = (e) => {
        updateDataState(e.dataState);
    };

    // save dataState object to userfilter table
    const updateDataState = (ds) => {
        setDataState(ds);
        setFilterActive(ds.filter !== undefined && ds.filter !== null);
        if (ds.filter !== undefined && ds.filter !== null) {
            let fs = "";
            for (let i = 0; i < ds.filter.filters.length; i++) {
                if (i > 0) fs = fs + ", ";
                fs +=
                    ds.filter.filters[i].filters[0].field +
                    " " +
                    ds.filter.filters[i].filters[0].operator +
                    " " +
                    ds.filter.filters[i].filters[0].value;
            }
            setFilterTitle(fs);
        }
        var q = `apiv7/userfilters`;
        var init = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            body: JSON.stringify({
                userId: GetSession().UserId,
                viewName: viewName,
                value: JSON.stringify(ds)
            })
        };
        fetch(configData.SERVER_URL + q, init);
    }

    if (params !== lastParams.current) {
        if (dataState.take !== 0) {
            let ds = { ...dataState };
            ds.skip = 0;
            updateDataState(ds);
        }
        lastParams.current = params;
    }

    // new data received from data loader
    const dataReceived = (d) => {
        if (d.total === "") return;
        let ids = "";
        totalRecords.current = d.total;
        d.data.map((r) => {
            if (ids !== "") ids += ",";
            ids += r[keyField];
        });
        setVisIds(ids);
        let pd = ParseDates(d);
        setData(pd);
    }

    const ParseDates = (d) => {
        // find any date fields and convert to JS date objects
        const re = new RegExp(/\d{4}-\d{2}-\d{2}[\sT]\d{2}:\d{2}:\d{2}/);
        if (d.data.length > 0) {
            for (var i = 0; i < d.data.length; i++) {
                if (dataSource.endsWith("transactions") && d.data[i].transactionTime) {
                    d.data[i].transactionDate = d.data[i].transactionTime;
                }
                for (var pr in d.data[i]) {
                    var val = d.data[i][pr];
                    switch (typeof val) {
                        case "string":
                            if (re.test(val)) {
                                let tz = "Z"
                                if (dataSource.endsWith("getlogs") && pr.toLowerCase() === "timestamp") {
                                    // The API's global converter labels database wall-clock values as UTC.
                                    // DatabaseLogger writes local time, so retain it without a timezone shift.
                                    d.data[i][pr] = new Date(val.replace(/(?:Z|[+-]\d{2}:?\d{2})$/i, ""));
                                    break;
                                }
                                const hasTimeZone = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(val);
                                d.data[i][pr] = new Date(hasTimeZone ? val : val + tz);
                            }
                            break;
                        case "boolean":
                            if (
                                pr.toLowerCase().indexOf("visible") < 0 &&
                                pr.toLowerCase().indexOf("available") < 0 &&
                                !dataSource.endsWith("vouchers")
                            ) {
                                if (pr.toLowerCase().indexOf("active") >= 0) {
                                    d.data[i][pr] = val ? "Active" : "Inactive";
                                } else {
                                    d.data[i][pr] = val ? "Yes" : "No";
                                }
                            }
                            break;
                        default:
                    }
                }
            }
        }
        return d;
    };


    const columnOrderChanged = (ev) => {
        let cols = [...stateColumns];
        let max = ev.columns.length;
        for (let i = 0; i < cols.length; i++) {
            if (cols[i].label !== "Action") {
                let f = ev.columns.find(s => s.title === cols[i].label);
                if (f === undefined) {
                    cols[i].orderIndex = max++;
                } else {
                    cols[i].orderIndex = f.orderIndex;
                }
            }
        }
        setStateColumns(cols);
        var t = viewName + "Columns";
        var q = `apiv7/userfilters`;
        var init = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + GetToken()
            },
            body: JSON.stringify({
                userId: GetSession().UserId,
                viewName: t,
                value: JSON.stringify(cols)
            })
        };
        fetch(configData.SERVER_URL + q, init);
    }

    React.useEffect(() => {
        if (!exportInProgress) return undefined;

        const preventPageExit = (event) => {
            event.preventDefault();
            event.returnValue = "";
        };

        window.__wmExportInProgress = true;
        window.addEventListener("beforeunload", preventPageExit);
        return () => {
            window.__wmExportInProgress = false;
            window.removeEventListener("beforeunload", preventPageExit);
        };
    }, [exportInProgress]);

    const requestExport = (type) => {
        setShowExportMenu(false);
        setExportError("");
        setPendingExport(type);
    };

    const requestRecordExport = (data) => {
        setExportError("");
        setPendingRecordExport(data);
    };

    // Fetch every matching row before handing it to the selected export component.
    const exportAllData = async (type) => {
        var url = configData.SERVER_URL + dataSource;
        var init = {
            method: 'GET',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + GetToken() }
        }
        if (dataSource.endsWith("transactions") || dataSource.endsWith("epareport")) {
            const baseUrl = (props.cloudToken !== undefined && props.cloudToken !== "" ? GetSession().CloudURL : configData.SERVER_URL);
            url = baseUrl + dataSource;
            init.headers = { "Authorization": "Bearer " + (props.cloudToken !== undefined && props.cloudToken !== "" ? props.cloudToken : GetToken()) };
        }
        const hasDataFilter = dataFilter !== undefined && dataFilter !== "";
        if (hasDataFilter) url += "?$filter=" + dataFilter;
        if (params !== undefined && params !== null && params !== "") url += (hasDataFilter ? "&" : "?") + `prm=${params}`;
        if (searchText !== "" && searchText !== undefined) url += (url.indexOf("?") > 0 ? "&" : "?") + "search=" + encodeURIComponent(searchText);
        try {
            const response = await fetch(url, init);
            if (!response.ok) throw new Error(`Export request failed (${response.status}).`);
            const d = await response.json();
            var x = { data: d };
            x = ParseDates(x);
            let xc = [];
            let c = undefined;
            if (aggregates !== undefined && dataState.group !== undefined && dataState.group.length > 0) {
                let gd = processWithGroups(x.data, dataState);
                for (let i = 0; i < stateColumns.length; i++) {
                    c = undefined;
                    if (stateColumns[i].orderIndex === undefined) {
                        if (stateColumns[i].isVisible) c = stateColumns[i];
                    } else {
                        c = stateColumns.find(obj => { return (obj.orderIndex === undefined || obj.orderIndex === i) && obj.isVisible });
                    }
                    if (c !== undefined) xc.push({
                        key: i,
                        field: c.field,
                        title: c.label,
                        groupFooter: xlFooter
                    });
                }
                if (type === "excel") {
                    await Promise.resolve(_export.current.save({ data: gd.data, group: dataState.group }, xc));
                } else {
                    await Promise.resolve(_pdfExport.current.save(x.data));
                }
            } else {
                for (let i = 0; i < stateColumns.length; i++) {
                    c = undefined;
                    if (stateColumns[i].orderIndex === undefined) {
                        if (stateColumns[i].isVisible) c = stateColumns[i];
                    } else {
                        c = stateColumns.find(obj => { return (obj.orderIndex === undefined || obj.orderIndex === i) && obj.isVisible });
                    }
                    if (c !== undefined) xc.push({
                        key: i,
                        field: c.field,
                        title: c.label
                    });
                }
                if (type === "excel") {
                    await Promise.resolve(_export.current.save(x.data, xc));
                } else {
                    await Promise.resolve(_pdfExport.current.save(x.data));
                }
            }
        } catch (error) {
            console.error("Data export failed", error);
            setExportError("The export could not be prepared. Please try again.");
        } finally {
            setExportInProgress(false);
        }
    }
    const xlFooter = (p) => {
        let x = p.aggregates[p.field];
        if (x === undefined) return "-";
        if (x.average !== undefined) return "Avg: " + x.average.toFixed(2);
        if (x.sum !== undefined) return x.sum.toFixed(2);
        return "-";
    }
    const _grid = React.useRef();
    const _export = React.useRef(null);
    const _pdfExport = React.useRef(null);
    const proceedWithExport = () => {
        const type = pendingExport;
        if (!type) return;
        if (type === "excel" && _export.current === null) return;
        if (type === "pdf" && _pdfExport.current === null) return;

        setPendingExport(null);
        setExportProgressMode("export");
        setExportInProgress(true);
        exportAllData(type);
    };

    const proceedWithRecordExport = async () => {
        const record = pendingRecordExport;
        if (!record || !props.exportRecord) return;

        setPendingRecordExport(null);
        setExportProgressMode("record");
        setExportInProgress(true);
        try {
            await Promise.resolve(props.exportRecord(record));
        } catch (error) {
            console.error("Record export failed", error);
            setExportError("The record export could not be prepared. Please try again.");
        } finally {
            setExportInProgress(false);
        }
    };

    const clearBulkSelection = () => {
        selectedIds.current = [];
        const ids = visIds ? visIds.split(",") : [];
        ids.forEach((id) => {
            if (id !== "") $("#Sel" + id).prop("checked", false);
        });
        $("input[name='SelectAll']").prop("checked", false);
    };

    const cancelBulkDownload = () => {
        setPendingBulkDownload(null);
        clearBulkSelection();
    };

    const exportBulk = () => {
        if (!bulkExport) return;

        const ids = selectedIds.current.join(",");
        if (ids === "") {
            alert("Please select records to download");
            return;
        }

        setExportError("");
        setPendingBulkDownload({ ids, count: selectedIds.current.length });
    }

    const proceedWithBulkDownload = async () => {
        const download = pendingBulkDownload;
        if (!download || !props.bulkExport) return;

        setPendingBulkDownload(null);
        setExportProgressMode("bulk");
        setExportInProgress(true);
        try {
            await Promise.resolve(props.bulkExport(download.ids));
            clearBulkSelection();
        } catch (error) {
            console.error("Bulk download failed", error);
            setExportError("The bulk download could not be prepared. Please try again.");
        } finally {
            setExportInProgress(false);
        }
    };

    const statusBulk = (st) => {
        if (bulkStatus) {
            let v = "";
            selectedIds.current.map((x) => {
                if (v !== "") v += ",";
                v += x;
            });
            if (v === "") {
                alert("Please select records for export");
                return;
            }
            props.bulkStatus(v, st);
            selectedIds.current = [];
        }
    }


    const importBulk = () => {
        if (props.importFile) props.importFile();
    }

    // display create new record button
    if (canCreate) {
        newRecordBtn = (
                <Button
                    type="button"
                    onClick={() => navigate(editUrl.startsWith("/") ? editUrl : "/" + editUrl)}
                    className="wm-data-grid__new-button"
                    title="Create New Record"
                    icon="plus"
                    style={newCol}
                >New</Button>
        );
    }

    // action buttons
    const CommandCell = (props) => {
        if (customCommand !== undefined && customCommandName !== undefined) {
            switch (customCommandName) {
                case "CustomCommand":
                    return (
                        <td  {...props.tdProps}>
                            <Button icon="arrow-up" onClick={() => customCommand("select", props.dataItem)} title="Select" />
                            <Button icon="edit" onClick={() => customCommand("edit", props.dataItem)} title="Edit" />
                            <Button icon="delete" hidden={!canDelete} onClick={() => DeleteRecord(props.dataItem)} title="Delete" style={delCol} />
                        </td>);
                case "SettingsCommand":
                    return (
                        <td {...props.tdProps}>
                            {props.dataItem.type === 0 && <Checkbox onChange={(ev) => customCommand(props.dataItem, ev)} size={"large"} defaultChecked={String(props.dataItem.value).toLowerCase() === "true"} />}
                            {(props.dataItem.type === 1 || props.dataItem.type === 2) && <NumericTextBox placeholder="Number" defaultValue={props.dataItem.value} onChange={(ev) => customCommand(props.dataItem, ev)} />}
                            {props.dataItem.type === 3 && <TextBox defaultValue={props.dataItem.value} onChange={(ev) => customCommand(props.dataItem, ev)} />}
                        </td>
                    );
                case "SyncSettingsCommand":
                    return (
                        <td {...props.tdProps}>
                            <NumericTextBox placeholder="Number" defaultValue={props.dataItem.syncPeriod} onChange={(ev) => customCommand(props.dataItem, ev)} />
                        </td>
                    );
                case "MyobSyncCommand":
                    return (
                        <td {...props.tdProps}>
                            <Button type="button" onClick={() => navigate((editUrl.startsWith("/") ? editUrl : "/" + editUrl) + "/" + props.dataItem[keyField])} icon="edit" hidden={!canEdit} title="Edit" style={editCol} />
                            <Button icon="delete" hidden={!canDelete} onClick={() => DeleteRecord(props.dataItem)} title="Delete" style={delCol} />
                            {props.dataItem.myobId !== null && syncMyob && <Button icon="connector" onClick={(ev) => customCommand(props.dataItem, ev)} title="Sync MYOB" style={myobCol} />}
                        </td>);
                case "FWCommand":
                    return (
                        <td {...props.tdProps}>
                            <Button type="button" onClick={() => navigate((editUrl.startsWith("/") ? editUrl : "/" + editUrl) + "/" + props.dataItem[keyField])} icon="edit" hidden={!canEdit} title="Edit" style={editCol} />
                            <Button icon="delete" hidden={!canDelete} onClick={() => DeleteRecord(props.dataItem)} title="Delete" style={delCol} />
                            <Button iconClass="fa fa-key fa-fw" onClick={(ev) => customCommand(props.dataItem, ev)} title="Convert to Transaction" style={convCol} />
                        </td>);
                case "RefundCommand":
                    let col = props.dataItem.isRefunded === "Yes" ? myobCol : feeCol;
                    let title = props.dataItem.isRefunded === "Yes" ? "Reverse Refund" : "Refund";
                    let icon = props.dataItem.isRefunded === "Yes" ? "arrow-rotate-ccw" : "dollar";
                    return (
                        <td {...props.tdProps}>
                            <Button type="button" onClick={() => navigate((editUrl.startsWith("/") ? editUrl : "/" + editUrl) + "/" + props.dataItem[keyField])} icon="edit" hidden={!canEdit} title="Edit" style={editCol} />
                            <Button icon="delete" hidden={!canDelete} onClick={() => DeleteRecord(props.dataItem)} title="Delete" style={delCol} />
                            <a href={printUrl + "/" + props.dataItem[keyField]}><Button icon="print" hidden={!canPrint} title="Print" style={printCol} /></a>
                            <Button icon="pdf" hidden={!canExport} title="Export Record" onClick={() => requestRecordExport(props.dataItem)} style={pdfCol} />
                            <Button icon={icon} title={title} onClick={() => customCommand(props.dataItem)} style={col} />
                        </td>);
                default:
                    return (null
                    );
            }
        }
        return (
            <td {...props.tdProps}>
                <Button type="button" onClick={() => navigate((editUrl.startsWith("/") ? editUrl : "/" + editUrl) + "/" + props.dataItem[keyField])} icon="edit" hidden={!canEdit} title="Edit" style={editCol} />
                <Button icon="delete" hidden={!canDelete} onClick={() => DeleteRecord(props.dataItem)} title="Delete" style={delCol} />
                <a href={printUrl + "/" + props.dataItem[keyField]}><Button icon="print" hidden={!canPrint} title="Print" style={printCol} /></a>
                <Button icon="pdf" hidden={!canExport} title="Export Record" onClick={() => requestRecordExport(props.dataItem)} style={pdfCol} />
                <Button icon={props.dataItem.isActive === "Active" ? "close" : "check"} hidden={!canApprove || props.dataItem.isApproved === "Yes"} onClick={() => Approve(props.dataItem)} title="Approve" style={pdfCol} />
                <a href={extraButtonUrl + "/" + props.dataItem[keyField]}><Button hidden={extraButton === undefined} title="Add fee" iconClass="fa fa-dollar fa-fw" style={feeCol} /></a>
            </td>);
    };

    const SelectCell = (props) => {
        let selName = "Sel" + props.dataItem[keyField];
        let chk = initialSelected === String(props.dataItem[keyField]);
        return (
            <td {...props.tdProps}>
                <Checkbox name={selName} id={selName} onChange={SetSelected} size={"large"} style={checkboxCol} defaultChecked={chk} />
            </td>
        )
    };

    // print callback if used
    const print = (dataItem) => {
        props.onPrint(dataItem);
    }

    // retrieve user filter for this view
    // UserFilter viewName = 'Products' is pagination and filtering -> dataState object
    // UserFilter viewName = 'ProductsColumns' is column selection  -> stateColumns object
    if (dataState !== undefined && dataState.take === 0) {
        var q = `apiv7/userfilters?$filter=userId eq ${GetSession().UserId} and viewName eq '${viewName}'`;
        const init = {
            method: 'GET',
            accept: 'application/json',
            headers: { "Authorization": "Bearer " + GetToken() }
        }
        fetch(configData.SERVER_URL + q, init).then(response => response.json()).then(d => {
            if (d.length > 0) {
                var st = JSON.parse(d[0].value);
                if (dataSource.endsWith("getlogs")) st.skip = 0;
                const restoredTake = pageSizeToTake(lastPageSize);
                if (!isNaN(restoredTake) && st.take !== restoredTake) {
                    st.skip = 0;
                    st.take = restoredTake;
                }
                setDataState(st);
                setFilterActive(st.filter !== undefined);
            } else {
                setDataState({ skip: 0, take: pageSizeToTake(lastPageSize) });
            }
        });
        q = `apiv7/userfilters?$filter=userId eq ${GetSession().UserId} and viewName eq '${viewName}Columns'`;
        fetch(configData.SERVER_URL + q, init).then(response => response.json()).then(d => {
            if (d.length > 0) {
                var cols = JSON.parse(d[0].value);
                let o = 0;
                for (let i = 0; i < cols.length; i++) {
                    if (cols[i].orderIndex !== undefined && cols[i].orderIndex > o) o = cols[i].orderIndex;
                }
                for (let i = 0; i < cols.length; i++) {
                    if (cols[i].orderIndex === undefined) cols[i].orderIndex = o++;
                }
                setStateColumns(cols);
            }
        });

    }
    // column selection changes
    const [stateColumns, setStateColumns] = React.useState(columns);
    const onColumnsSubmit = (columnsState) => {
        setStateColumns(columnsState);
    }

    // Delete operation
    // display confirm dialog to delete record
    const DeleteRecord = (data) => {
        setSelected(data[keyField]);
        setShowDlg(true);
    };

    const DeleteAll = () => {
        setSelected(0);
        setShowDlg(true);
    };

    // close confirm dialog
    const HideMessage = () => {
        setShowDlg(false);
    };

    // post delete message to API
    const DeleteData = () => {
        const baseUrl = (props.cloudToken !== undefined && props.cloudToken !== "" ? GetSession().CloudURL : configData.SERVER_URL);

        setShowDlg(false);
        var init = {
            method: "DELETE",
            headers: { "Authorization": "Bearer " + (props.cloudToken !== undefined && props.cloudToken !== "" ? props.cloudToken : GetToken()) }
        }
        var url = baseUrl + `${dataSource}/${selected}`;
        if (selected === 0) {
            url = `${baseUrl}${dataSource}?selected=${visIds}`;
        }
        fetch(url, init).then().then(d => {
            UpdateGrid();
            setSuccess(true)
            setTimeout(() => {
                setSuccess(false);
            }, 1000);

        });
    };

    // force an update of Grid. Kendo doesn't make it easy but backuping up state, setting take to 1 and restoring state works
    const UpdateGrid = () => {
        setGridKey(new Date());
    };

    React.useEffect(() => {
        let url = `${configData.SERVER_URL}apiv7/settings`;
        const init = {
            method: "GET",
            accept: "application/json",
            headers: { "Authorization": "Bearer " + GetToken() },
        };
        fetch(url, init).then(response => response.json()).then(d => {
            if (d.length > 0) {
                let st = d.find(obj => { return obj.name === "ShowPDFExport"});
                if (st !== undefined) setShowExportPDF(st.value.toLowerCase() === "true");
            }
        });
        if (props.update && props.update !== "") UpdateGrid(); 
    }, [props.update]);

    const SetSelected = (e) => {
        let id = e.target.name.replace("Sel", "");
        let newIds = [];
        let selIds = selectedIds.current;
        selIds.forEach((x) => {
            if (x !== id) newIds.push(x);
        });
        if (e.value) newIds.push(id);
        selectedIds.current = newIds;
    }

    const CustomHeaderCell = (props) => (
        <HeaderThElement>
            {props.index === 0 && (bulkExport || bulkStatus) ? <Checkbox name="SelectAll" onChange={SelectAll} style={checkboxCol} /> : props.children}
        </HeaderThElement>
    )

    const SelectAll = (e) => {
        let newIds = [];
        var sp = visIds.split(',');
        for (var i = 0; i < sp.length; i++) {
            if (e.value) newIds.push(sp[i]);
            $("#Sel" + sp[i]).prop("checked", e.value);
        }
        selectedIds.current = newIds;
    }

    const CustomCell = (props) => {
        const f = props.field;
        let val = "";
        let sp = String(f).split(".");
        if (sp.length > 1) {
            let par = props.dataItem[sp[0]];
            val = par[sp[1]];
        } else {
            val = props.dataItem[f];
        }
        if (props.format === null || props.format === "") {
            if (typeof props.dataItem[f] === "boolean") {
                switch (props.field) {
                    case "isVisible":
                    case "isActive":
                        let cbid = "CB" + props.dataItem[keyField];
                        return (
                            <td {...props.tdProps}>
                                <Checkbox
                                    name={cbid}
                                    onChange={VisibilityChanged}
                                    defaultChecked={val}
                                />{" "}
                            </td>
                        );
                    case "isVisibleOnMobile":
                        let ivid = "VM" + props.dataItem[keyField];
                        return (
                            <td {...props.tdProps}>
                                <Checkbox
                                    name={ivid}
                                    onChange={VisibilityChanged}
                                    defaultChecked={val}
                                />{" "}
                            </td>
                        );
                    case "isAvailable":
                        let avid = "AV" + props.dataItem[keyField];
                        return (
                            <td {...props.tdProps}>
                                <Checkbox
                                    name={avid}
                                    onChange={VisibilityChanged}
                                    defaultChecked={val}
                                />{" "}
                            </td>
                        );
                    default:
                        if (val) {
                            return <td {...props.tdProps}>Yes</td>;
                        } else {
                            return <td {...props.tdProps}>No</td>;
                        }
                }
            } else {
                if (val === "Active" || val === "Inactive") {
                    return (
                        <td {...props.tdProps}>
                            <span className={"wm-data-grid__status wm-data-grid__status--" + val.toLowerCase()}>
                                <span aria-hidden="true" />
                                {val}
                            </span>
                        </td>
                    );
                }
                return <td {...props.tdProps}>{val}</td>;
            }
        } else {
            const fmt = String(props.format.replace("{0:", "").replace("}", ""));
            if (fmt.startsWith("c") || fmt.startsWith("n"))
                return <td {...props.tdProps}>{formatNumber(val, fmt)}</td>;
            else return <td {...props.tdProps}>{formatDate(val, fmt)}</td>;
        }
    };

    const VisibilityChanged = (ev) => {
        setVisibility(ev.target.name, ev.target.value);
    };

    const clearFilters = () => {
        let ds = { ...dataState };
        ds.filter = undefined;
        updateDataState(ds);
    };

    const DoSearch = () => {
        let ds = { ...dataState };
        ds.skip = 0;
        setDataState(ds);
        updateDataState(ds);
        setSearchText(searchEntry);
        localStorage.setItem(dataSource + "Search", searchEntry);
    }
    searchHandler.current = DoSearch;

    const ClearSearch = () => {
        setSearchEntry("");
        let ds = { ...dataState };
        ds.skip = 0;
        setDataState(ds);
        updateDataState(ds);
        setSearchText("");
        localStorage.setItem(dataSource + "Search", "");
    }

    const lastSearchResetKey = React.useRef(props.searchResetKey);
    React.useEffect(() => {
        if (lastSearchResetKey.current === props.searchResetKey) return;
        lastSearchResetKey.current = props.searchResetKey;
        ClearSearch();
    }, [props.searchResetKey]);

    const SearchTextChanged = (e) => {
        setSearchEntry(e.value);
    };

    const onSearchKeyDown = (event) => {
        if (event.key === "Enter") {
            event.preventDefault();
            if (searchEntry !== searchText) DoSearch();
        }
    };

    const onRowClick = (event) => {
        event.nativeEvent.preventDefault();
        if (props.onRowClick && event.dataItem) props.onRowClick(event.dataItem);
    };

    const GroupCustomCell = props => {
        if (aggregates === undefined) return (<td></td>);
        let cellContent;
        let x = aggregates.find(obj => obj.field === props.field);
        if (x !== undefined && x.aggregate === "sum") cellContent = parseFloat(props.dataItem.aggregates[props.field].sum).toFixed(2);
        if (x !== undefined && x.aggregate === "average") cellContent = "Avg: " + parseFloat(props.dataItem.aggregates[props.field].average).toFixed(2);
        return <td {...props.tdProps} colSpan={1}>
            {cellContent}
        </td>;
    };

    const processWithGroups = (data, dataState) => {
        let ds = { ...dataState };
        ds.group = dataState.group?.map(group => ({ ...group, aggregates: aggregates || [] }));
        ds.skip = 0; // skip already done from API so don't skip
        ds.take = 9999999;
        const newDataState = process(data, ds);
        setGroupIds({
            data: newDataState.data,
            group: ds.group
        });
        return newDataState;
    };

    // Group the loaded page whenever descriptors change, even without a new API response.
    const gridData = dataState.group?.length
        ? { data: processWithGroups(apiData.data, dataState).data, total: apiData.total }
        : apiData;

    // multiple purpose datagrid with all the bells and whistles
    const dataGrid = (
        <Grid
            key={gridKey ? gridKey.valueOf() : "grid"}
            className="wm-data-grid__grid"
            data={gridData}
            dataItemKey={keyField}
            scrollable="scrollable"
            sortable={sortable}
            fixedScroll={true}
            onRowClick={onRowClick}
            pageable={{
                buttonCount: 4,
                pageSizes: [10, 20, 50, 100, 200, "All"],
                pageSizeValue: pageSizeValue,
            }}
            reorderable={true}
            resizable={true}
            style={{
                maxHeight: gridMaxHeight,
                maxWidth: '100%'
            }}
            {...dataState}
            onDataStateChange={dataStateChange}
            onPageChange={pageChange}
            onColumnReorder={columnOrderChanged}
            ref={_grid}
            cells={{ headerCell: CustomHeaderCell, groupFooter: GroupCustomCell }}
            detail={props.details}
            filterOperators={filterOperators}
            groupable={{
                footer: 'visible',
                enabled: aggregates !== undefined
            }}
            autoProcessData={false}
        >
            <GridToolbar>
                <div className="wm-data-grid__toolbar">
                    <div className="wm-data-grid__toolbar-actions">
                        {newRecordBtn}
                        {canReport && (
                            <div className="wm-data-grid__menu" ref={exportButtonRef}>
                                <Button className="wm-data-grid__export-button" icon="download" onClick={toggleExportMenu}>
                                    Export <i className="fa-solid fa-chevron-down" aria-hidden="true" />
                                </Button>
                            </div>
                        )}
                        {bulkStatus && <Button icon="check-circle" title="Make selected records active" onClick={() => statusBulk(true)} style={statusActiveCol} />}
                        {bulkStatus && <Button icon="x-circle" title="Make selected records inactive" onClick={() => statusBulk(false)} style={statusInactiveCol} />}
                        {bulkExport && (
                            <Button className="wm-data-grid__bulk-download-button" icon="download" title="Download selected dockets" onClick={exportBulk}>
                                Bulk Download
                            </Button>
                        )}
                        {canImport && <Button icon="upload" title="Import Data" onClick={() => importBulk()} style={importCol} />}
                        {deleteAll && (
                            <Button title="Delete Records Currently Being Displayed" icon="delete" onClick={DeleteAll} style={delCol}>
                                Delete These Records
                            </Button>
                        )}
                        {filterActive && (
                            <Button title={filterTitle} icon="filter-clear" onClick={clearFilters} style={clearCol}>
                                Clear Filters
                            </Button>
                        )}
                    </div>
                    <div className="wm-data-grid__search">
                        <i className="fa-solid fa-magnifying-glass" aria-hidden="true" />
                        <TextBox
                            id="SearchText"
                            autoFocus
                            aria-label="Search in results"
                            onChange={SearchTextChanged}
                            onKeyDown={onSearchKeyDown}
                            value={searchEntry}
                            placeholder="Search in results..."
                        />
                        {(searchEntry !== "" || searchText !== "") && <Button type="button" themeColor="error" className="wm-data-grid__clear-button wm-search-clear" onClick={ClearSearch}>Clear</Button>}
                    </div>
                </div>
            </GridToolbar>
            {(bulkExport || bulkStatus) && <GridColumn
                cells={{ data: SelectCell }}
                width="44px"
                locked={true}
                orderIndex={-1}
            />}
            <GridColumn
                title="Action"
                cells={{ data: CommandCell }}
                width={colWidth}
                locked={true}
                orderIndex={-1}
            />
            {stateColumns && stateColumns.map(
                (column, idx) =>
                    column.isVisible && (
                        <GridColumn
                            key={idx}
                            field={column.field}
                            title={column.label}
                            filter={column.type}
                            format={column.format}
                            dataType={column.type}
                            width={getReadableColumnWidth(column)}
                            cell={{ data: CustomCell }}
                            orderIndex={column.orderIndex}
                            columnMenu={(props) => (
                                <ColumnMenu
                                    {...props}
                                    options={apiData.data}
                                    filterable={filterable}
                                    columns={stateColumns}
                                    viewName={viewName}
                                    onColumnsSubmit={onColumnsSubmit}
                                />
                            )}
                        />
                    )
            )}
        </Grid>
    );
    return (
        <div className="wm-data-grid" ref={gridContainerRef}>
            <NotificationGroup style={{ right: 2080, bottom: 1185, alignItems: "flex-start", flexWrap: "wrap-reverse" }}>
                <Fade>{success && (<Notification type={{ style: "success", icon: true, }} closable={true} onClose={() => setSuccess(false)}> <span>Record Deleted.</span> </Notification>)} </Fade>
            </NotificationGroup>
            {showExportMenu && exportMenuPosition && (
                <div
                    className="wm-data-grid__menu-panel wm-data-grid__menu-panel--floating"
                    role="menu"
                    style={{
                        top: `${exportMenuPosition.top}px`,
                        left: `${exportMenuPosition.left}px`,
                        minWidth: `${Math.max(160, exportMenuPosition.width)}px`
                    }}
                    onClick={(event) => event.stopPropagation()}
                >
                    {canReport && <button type="button" role="menuitem" onClick={() => requestExport("excel")}><i className="fa-solid fa-file-excel" aria-hidden="true" /> Excel</button>}
                    {showExportPDF && canReport && <button type="button" role="menuitem" onClick={() => requestExport("pdf")}><i className="fa-solid fa-file-pdf" aria-hidden="true" /> PDF</button>}
                </div>
            )}
            <DatePickerPropsContext.Provider value={datePickerProps}>
                <ExcelExport ref={_export}></ExcelExport>
                {dataGrid}
                {showExportPDF && <GridPDFExport ref={_pdfExport}></GridPDFExport>}
            </DatePickerPropsContext.Provider>
            {dataState !== undefined && dataState.take > 0 && <DataLoader
                key={gridKey}
                gridContainer={gridContainerRef}
                dataState={dataState}
                dataFilter={dataFilter}
                onDataReceived={dataReceived}
                dataSource={dataSource}
                params={params}
                search={searchText}
                cloudToken={props.cloudToken}
            />}
            {showDlg && (
                <Confirm
                    YesClicked={DeleteData}
                    NoClicked={HideMessage}
                    Title="Confirm delete"
                    Message="Are you sure you want to delete?"
                />
            )}
            {pendingExport && (
                <Dialog title={`Export ${totalRecords.current.toLocaleString()} entries?`} onClose={() => setPendingExport(null)}>
                    <p className="wm-data-grid__export-message">
                        Preparing this {pendingExport === "excel" ? "Excel" : "PDF"} export may take a while.
                        Keep this page open until the download starts.
                    </p>
                    <DialogActionsBar>
                        <Button onClick={() => setPendingExport(null)}>Cancel</Button>
                        <Button themeColor="primary" onClick={proceedWithExport}>Proceed</Button>
                    </DialogActionsBar>
                </Dialog>
            )}
            {pendingRecordExport && (
                <Dialog title={`Export docket ${pendingRecordExport.docket || pendingRecordExport[keyField]}?`} onClose={() => setPendingRecordExport(null)}>
                    <p className="wm-data-grid__export-message">
                        Preparing this record export may take a while.
                        Keep this page open until the download starts.
                    </p>
                    <DialogActionsBar>
                        <Button onClick={() => setPendingRecordExport(null)}>Cancel</Button>
                        <Button themeColor="primary" onClick={proceedWithRecordExport}>Proceed</Button>
                    </DialogActionsBar>
                </Dialog>
            )}
            {pendingBulkDownload && (
                <Dialog title={`Bulk download ${pendingBulkDownload.count.toLocaleString()} selected docket${pendingBulkDownload.count === 1 ? "" : "s"}?`} onClose={cancelBulkDownload}>
                    <p className="wm-data-grid__export-message">
                        Preparing this bulk download may take a while.
                        Keep this page open until the ZIP download starts.
                    </p>
                    <DialogActionsBar>
                        <Button onClick={cancelBulkDownload}>Cancel</Button>
                        <Button themeColor="primary" onClick={proceedWithBulkDownload}>Proceed</Button>
                    </DialogActionsBar>
                </Dialog>
            )}
            {exportError && (
                <Dialog title={exportProgressMode === "bulk" ? "Download unsuccessful" : "Export unsuccessful"} onClose={() => setExportError("")}>
                    <p>{exportError}</p>
                    <DialogActionsBar>
                        <Button themeColor="primary" onClick={() => setExportError("")}>Close</Button>
                    </DialogActionsBar>
                </Dialog>
            )}
            {exportInProgress && (
                <div className="wm-data-grid__export-overlay" role="alertdialog" aria-modal="true" aria-labelledby="export-progress-title">
                    <div className="wm-data-grid__export-progress">
                        <span className="wm-data-grid__spinner" aria-hidden="true" />
                        <h2 id="export-progress-title">{exportProgressMode === "bulk" ? "Preparing your bulk download" : "Preparing your export"}</h2>
                        <p>Please keep this page open until the download starts.</p>
                    </div>
                </div>
            )}

        </div>
    );
};

export default DataGrid;


